import { render, staticRenderFns } from "./ButtonActionSortCategoriesAZ.vue?vue&type=template&id=ee42d490&scoped=true&"
var script = {}
import style0 from "./ButtonActionSortCategoriesAZ.vue?vue&type=style&index=0&id=ee42d490&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee42d490",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VHover,VIcon,VTooltip})
